// extracted by mini-css-extract-plugin
export default {"root":"Popper_root__ENH6-","content":"Popper_content__zxHLX"};